module.exports = __webpack_public_path__ + "static/flags/TZ-6c1da3defa4fd8d92d4563a1e8786611.gif";